import elBG from 'element-ui/lib/locale/lang/bg'
import elcsCZ from 'element-ui/lib/locale/lang/cs-CZ'
import elDE from 'element-ui/lib/locale/lang/de'
import elEL from 'element-ui/lib/locale/lang/el'
import elEN from 'element-ui/lib/locale/lang/en'
import elES from 'element-ui/lib/locale/lang/es'
import elFI from 'element-ui/lib/locale/lang/fi'
import elFR from 'element-ui/lib/locale/lang/fr'
import elHR from 'element-ui/lib/locale/lang/hr'
import elHU from 'element-ui/lib/locale/lang/hu'
import elIT from 'element-ui/lib/locale/lang/it'
import elnbNO from 'element-ui/lib/locale/lang/nb-NO'
import elNL from 'element-ui/lib/locale/lang/nl'
import elPL from 'element-ui/lib/locale/lang/pl'
import elPT from 'element-ui/lib/locale/lang/pt'
import elRO from 'element-ui/lib/locale/lang/ro'
import elSK from 'element-ui/lib/locale/lang/sk'
import elSL from 'element-ui/lib/locale/lang/sl'
import elSR from 'element-ui/lib/locale/lang/sr'
import elsvSE from 'element-ui/lib/locale/lang/sv-SE'
import eltrTR from 'element-ui/lib/locale/lang/tr-TR'

export default (locale, fallbackLocale) => {
  const enableSilentTranslationWarn =
    locale !== 'en-GB' && process.env.NODE_ENV === 'development'

  if (enableSilentTranslationWarn) {
    console.log('i18n silentTranslationWarn is enabled 😌')
  }
  return {
    silentTranslationWarn: enableSilentTranslationWarn,
    locale,
    fallbackLocale: {
      nl: ['nl-NL'],
      en: ['en-GB'],
      de: ['de-DE'],
      fr: ['fr-FR'],
      sv: ['sv-SE'],
      'es-ES': ['es'],
      'bg-BG': ['bg'],
      'cs-CZ': ['cs'],
      'el-GR': ['el'],
      'fi-FI': ['fi'],
      'hr-HR': ['hr'],
      'hu-HU': ['hu'],
      'it-IT': ['it'],
      'nb-NO': ['nb'],
      'pl-PL': ['pl'],
      'pt-PT': ['pt'],
      'ro-RO': ['ro'],
      'sr-RS': ['sr'],
      'sk-SK': ['sk'],
      'sl-SI': ['sl'],
      'tr-TR': ['tr'],
      'en-BE': ['en-GB'],
      default: [fallbackLocale]
    },
    messages: {
      bg: { ...require('~/locales/bg.json'), ...elBG },
      cs: { ...require('~/locales/cs.json'), ...elcsCZ },
      'de-AT': { ...require('~/locales/de-AT.json'), ...elDE },
      'de-DE': { ...require('~/locales/de-DE.json'), ...elDE },
      el: { ...require('~/locales/el.json'), ...elEL },
      'en-GB': { ...require('~/locales/en-GB.json'), ...elEN },
      'en-IE': { ...require('~/locales/en-IE.json'), ...elEN },
      es: { ...require('~/locales/es.json'), ...elES },
      fi: { ...require('~/locales/fi.json'), ...elFI },
      'fr-BE': { ...require('~/locales/fr-BE.json'), ...elFR },
      'fr-FR': { ...require('~/locales/fr-FR.json'), ...elFR },
      'fr-LU': { ...require('~/locales/fr-LU.json'), ...elFR },
      hr: { ...require('~/locales/hr.json'), ...elHR },
      hu: { ...require('~/locales/hu.json'), ...elHU },
      it: { ...require('~/locales/it.json'), ...elIT },
      nb: { ...require('~/locales/nb.json'), ...elnbNO },
      'nl-BE': { ...require('~/locales/nl-BE.json'), ...elNL },
      'nl-NL': { ...require('~/locales/nl-NL.json'), ...elNL },
      pl: { ...require('~/locales/pl.json'), ...elPL },
      pt: { ...require('~/locales/pt.json'), ...elPT },
      ro: { ...require('~/locales/ro.json'), ...elRO },
      sk: { ...require('~/locales/sk.json'), ...elSK },
      sl: { ...require('~/locales/sl.json'), ...elSL },
      sr: { ...require('~/locales/sr.json'), ...elSR },
      'sv-FI': { ...require('~/locales/sv-FI.json'), ...elsvSE },
      'sv-SE': { ...require('~/locales/sv-SE.json'), ...elsvSE },
      tr: { ...require('~/locales/tr.json'), ...eltrTR }
    }
  }
}
